export const INDICA = 'Indica';
export const SATIVA = 'Sativa';
export const HYBRID = 'Hybrid';
export const INDICA_HYBRID = 'Indica Hybrid';
export const SATIVA_HYBRID = 'Sativa Hybrid';
